export default __webpack_public_path__ + "fonts/solution-balloon.svg";